import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import CardProcessorOfferWrapper from "@components/layouts/cardProcessorOffersWrapper";

import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function CardProcessingOffersHome(): ReactElement {
    return (
        <CardProcessorOfferWrapper>
            <TermsAndConditions
                category="Card Processing Offers"
                domain="CardProcessingOffers.com"
            />
        </CardProcessorOfferWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
